import s from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={s.footer}>
      <div className={s.text}>©2023 Kimoji Gacha by @artiface</div>
    </div>
  );
};

export { Footer };
